<script>
import GenericCrud from "@forms/GenericCrud.vue";

export default {
  extends: GenericCrud,
  props: {
    table: {
      type: String,
      default: "Feriado"
    }
  }
};
</script>

<template>
  <div>
    <b-form @submit.prevent="save">
      <b-form-group id="input-group-1" label="Descrição" label-for="descricao">
        <b-form-input
          id="descricao"
          v-model="item.descricao"
          type="text"
          :disabled="!this.editForm"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group id="input-group-1" label="Tipo" label-for="tipo">
        <b-form-select
          id="tipo"
          v-model="item.tipo"
          type="text"
          :disabled="!this.editForm"
          required
        >
          <b-form-select-option value="Municipal"
            >Municipal</b-form-select-option
          >
          <b-form-select-option value="Estadual">Estadual</b-form-select-option>
          <b-form-select-option value="Nacional">Nacional</b-form-select-option>
        </b-form-select>
      </b-form-group>

      <b-form-group id="input-group-1" label="Data" label-for="data">
        <b-form-datepicker
          id="data"
          v-model="item.data"
          :disabled="!this.editForm"
          required
          placeholder="Selecione uma data"
          :hide-header="true"
        ></b-form-datepicker>
      </b-form-group>
      <b-form-group id="input-group-1" label-for="recorrente" class="mt-3">
        <b-form-checkbox
          id="recorrente"
          v-model="item.recorrente"
          value="true"
          :disabled="!this.editForm"
          unchecked-value="false"
          >Recorrente
        </b-form-checkbox>
      </b-form-group>

      <b-form-group id="button-group" class="mt-4" v-show="this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Cancelar</b-button
        >
        <b-button type="submit" variant="primary" class="btn ml-2"
          >Salvar</b-button
        >
      </b-form-group>

      <b-form-group id="button-group" class="mt-4" v-show="!this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Voltar</b-button
        >
        <b-button variant="primary" class="btn ml-2" v-on:click="edit()"
          >Editar</b-button
        >
        <b-button variant="danger" class="btn ml-2" v-on:click="remove()"
          >Remover</b-button
        >
      </b-form-group>
    </b-form>
    <b-modal
      v-model="showModalDelete"
      title="Deseja realmente excluir?"
      centered
      hide-footer
      @hidden="cancelRemove()"
    >
      <div class="button-list float-right">
        <b-button
          class="btn btn btn-icon"
          variant="primary"
          v-on:click="confirmRemove()"
          >Sim</b-button
        >
        <b-button
          class="btn btn btn-icon"
          variant="light"
          @click="showModalDelete = false"
          >Não</b-button
        >
      </div>
    </b-modal>
  </div>
</template>
